<template>
    <!-- MY1-3080: first step of "Add usage" on an auto-tracked benefit — pick
         a My Spending transaction, or fall through to the manual form (which
         the design marks "already implemented and does not change"). -->
    <div
        class="flex min-w-[240px] flex-col p-1"
        role="menu"
        data-test="add-usage-menu"
    >
        <button
            type="button"
            role="menuitem"
            class="flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-slate-800 hover:bg-slate-100 focus:bg-slate-100 focus:outline-none dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:bg-slate-700"
            data-test="add-from-spending"
            @click.stop="$emit('spending')"
        >
            <Icon
                icon="bank-financial"
                class="h-5 w-5 shrink-0 text-slate-500 dark:text-slate-400"
            />
            Add from My Spending
        </button>
        <button
            type="button"
            role="menuitem"
            class="flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-slate-800 hover:bg-slate-100 focus:bg-slate-100 focus:outline-none dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:bg-slate-700"
            data-test="enter-manually"
            @click.stop="$emit('manual')"
        >
            <Icon
                icon="pencil"
                class="h-5 w-5 shrink-0 text-slate-500 dark:text-slate-400"
            />
            Enter manually
        </button>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

defineEmits(['spending', 'manual']);
</script>
